import { render, staticRenderFns } from "./editClientDocument.vue?vue&type=template&id=13aebcde&"
import script from "./editClientDocument.vue?vue&type=script&lang=js&"
export * from "./editClientDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports